import { Dispatch, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  Actions,
  AppState,
  AUTHORIZE_NAVIGATION_VIDEOS_SUCCESS,
  authorizeNavigationVideos,
  fetchNavigationVideos,
  actionListPath,
  notFoundPath,
  navigationVideosPath,
} from "../studentStore";
import useWaitApiCall from "../hooks/useWaitApiCall";

type Args = {
  state: AppState;
  dispatch: Dispatch<Actions>;
};

const useNavigationVideo = ({ state, dispatch }: Args) => {
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const location = useLocation();

  const isNavigationVideosPath = location.pathname === navigationVideosPath;

  const isNavigationVideoAuthorizationRequired =
    state.navigationVideoErrorCode ===
    "navigation_video_authorization_required";

  const isNavigationVideoNotAvailable =
    state.navigationVideoErrorCode === "navigation_video_not_available";

  const displayLocation = (() => {
    if (!isNavigationVideosPath) {
      return location;
    }

    if (isNavigationVideoNotAvailable) {
      return { ...location, pathname: notFoundPath };
    }

    if (isNavigationVideoAuthorizationRequired) {
      return { ...location, pathname: actionListPath };
    }

    return location;
  })();

  useEffect(() => {
    if (state.session_id && isNavigationVideosPath) {
      dispatch(fetchNavigationVideos());
    }
  }, [dispatch, isNavigationVideosPath, state.session_id]);

  useEffect(() => {
    if (
      isNavigationVideosPath &&
      state.lastAction === AUTHORIZE_NAVIGATION_VIDEOS_SUCCESS
    ) {
      dispatch(fetchNavigationVideos());
    }
  }, [dispatch, isNavigationVideosPath, state.lastAction]);

  const authorize = (password: string) => {
    dispatch(peep(authorizeNavigationVideos(password)));
  };

  const closePasswordModal = () => {
    history.replace(actionListPath);
  };

  return {
    calling,
    location: displayLocation,
    isShowPasswordModal:
      isNavigationVideosPath && isNavigationVideoAuthorizationRequired,
    closePasswordModal,
    authorize,
  };
};

export default useNavigationVideo;
